import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';

import BaseMenu from '../base/base-menu';

import SecondaryMenu from '../../components/shared/secondary-menu/secondary-menu';
import Actions from '../../actions';
import { addProductToCartNotifyEP } from '../../errors/processors/add-product-to-cart';
import refreshOrderProcess from '../../services/refresh-order-process';
import translations from '../../../translations/app-translations.json';

const distinctProducts = (products) => {
    const productsFilters = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const product of products) {
        const filterCondition = productsFilters.findIndex((item) => item.id === product.id) === -1;
        if (filterCondition) {
            productsFilters.push(product);
        }
    }
    return productsFilters;
};

const fetchedProducts = (dispatch, locale) => dispatch(Actions.fetchProducts({ page_no: 1, locale })).then((response) => {
    const fetchedProducts = response.body;

    dispatch(Actions.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
    dispatch(Actions.hideLoader());
});

const mapStateToProps = (state, ownProps) => ({
    availableZones: state.zones.availableZones,
    access_token: state.auth.access_token,
    currentZone: state.zones.currentZone,
    stores: state.stores.stores,
    storesGrouped: state.stores.storesGrouped,
    currentStore: state.stores.currentStore,
    currentMunicipality: state.municipalities.currentMunicipality,
    availableMunicipalities: state.municipalities.availableMunicipalities,
});

const mapDispatchToProps = (dispatch) => ({
    submitPriceForm: (priceMin, priceMax, path) => {
        if (priceMin && priceMax) {
            dispatch(push(`${path}?price_min=${priceMin}&price_max=${priceMax}`));
        }
    },
    addProductToCart: (variantId, quantity = 1, zoneId, locale, userToken) => {
        dispatch(Actions.addProductToCart(variantId, quantity, zoneId, locale, userToken))
            .then(() => {
                refreshOrderProcess(dispatch, locale, toastr, {
                    addingProductToCartAction: false,
                    successNotify: `${translations[locale]['item-added']}. ${translations[locale]['proceed-to-checkout']}.`,
                });
            })
            .catch((error) => {
                addProductToCartNotifyEP(locale, error, toastr);
            });
    },
    emptyCart: (order, locale) => dispatch(Actions.emptyCart(order, locale)),
    setCurrentZone: (zoneId) => dispatch(Actions.setCurrentZone(zoneId)),
    setCurrentStore: (currentStore) => {
        dispatch(Actions.displayLoader());
        dispatch(Actions.fetchStorePayments(currentStore)).then(() => {
            fetchedProducts(dispatch);
        }).catch((err) => console.log(err));
    },
    loadGroupedStores: () => dispatch(Actions.loadGroupedStores()),
    setCurrentMunicipality: (municipalityId) => dispatch(Actions.setCurrentMunicipality(municipalityId)),
});

const SecondaryMenuConnector = connect(mapStateToProps, mapDispatchToProps)(SecondaryMenu);

export default BaseMenu(SecondaryMenuConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/menus/secondary-menu-connector.js
 **/